import { getRqbStore } from './getRqbStore';
import type { RqbStore } from './types';

export const queryBuilderStore: RqbStore = getRqbStore();
